import { UPCOMING_GAMES_LABEL } from 'constants';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetNews } from 'hooks';
import { logEvent } from 'firebase/analytics';
import { getAnalyticsInstance } from 'firebase.js';
import { NewsSlide } from './NewsSlide/NewsSlide';
import { NewsSlideWrapper } from './style.js';

export const NewsFeed = () => {
  const analytics = getAnalyticsInstance();
  const [searchParams] = useSearchParams();
  const teamId = searchParams.get('teamId');
  const team = searchParams.get('team');
  const leagueId = searchParams.get('leagueId');

  const configData = useSelector((state) => state.configuration?.data);

  const isOneLeague =
    configData?.display_one_league === '1' ||
    configData?.display_one_league === 1;
  const isOneTeam =
    configData?.display_one_team === '1' || configData?.display_one_team === 1;

  const isUpcomingEvents = team === UPCOMING_GAMES_LABEL;
  const hasRealTeamSelected = !!teamId && !isUpcomingEvents;
  const isLeagueSpecific =
    (isOneLeague && !isOneTeam && !hasRealTeamSelected) || isUpcomingEvents;
  const effectiveLeagueId = isLeagueSpecific
    ? configData?.one_league_id || leagueId
    : null;

  const { status, data } = useGetNews(
    teamId,
    effectiveLeagueId,
    isLeagueSpecific
  );

  if (status === 'error') {
    logEvent(analytics, 'select_content', {
      content_type: 'error',
      content_id: isLeagueSpecific
        ? `News fetching error for league with leagueId ${effectiveLeagueId} and site url: ${window.location.href}`
        : `News fetching error for team ${team} with teamId ${teamId} and site url: ${window.location.href}`,
    });
  }

  const newsData = status === 'success' && data?.data?.length ? data.data : [];

  return (
    <NewsSlideWrapper>
      {newsData.length > 0 ? (
        <NewsSlide news={newsData} />
      ) : (
        <div style={{ height: '40px', visibility: 'hidden' }}>&nbsp;</div>
      )}
    </NewsSlideWrapper>
  );
};
